import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';

export const handleCreateArea = (isIncome, setOpenNewAreaModal, setCreateIncomeArea, setSelectedCategory, category) => {
  setOpenNewAreaModal(true);
  setCreateIncomeArea(isIncome);
  setSelectedCategory(category);
};

const CreateAreaModal = ({ createIncomeArea, categoryId, onAreasChange = () => {} }) => {
  const { t } = useTranslation('finance');
  const [newAreas, setNewAreas] = useState([]);

  React.useEffect(() => {
    setNewAreas([]);
  }, [categoryId]);

  React.useEffect(() => {
    if (onAreasChange) {
      onAreasChange({
        areas: newAreas,
        categoryId,
      });
    }
  }, [newAreas, categoryId, onAreasChange]);

  const handleInputChange = (e) => {
    const areaName = e.target.value.trim();
    setNewAreas(areaName ? [areaName] : []);
  };

  const typeKey = createIncomeArea ? 'income' : 'expense';

  return (
    <div className="tw-space-y-6">
      <div className="tw-flex tw-items-center tw-gap-3 tw-pb-4 tw-border-b tw-border-gray-200">
        <div className={`tw-p-2 tw-rounded-lg ${createIncomeArea ? 'tw-bg-green-100' : 'tw-bg-red-100'}`}>
          <Icon name="chart area" color={createIncomeArea ? 'green' : 'red'} size="large" />
        </div>
        <div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-gray-900">
            {t(`categoryModals.${typeKey}`)}
          </h3>
          <p className="tw-text-sm tw-text-gray-600">
            {t(`categoryModals.createAreaSubtitle${createIncomeArea ? 'Income' : 'Expense'}`)}
          </p>
        </div>
      </div>

      <div className="tw-space-y-2">
        <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
          {t('categoryModals.areaName')} <span className="tw-text-red-500">*</span>
        </label>
        <div className="tw-flex tw-gap-2">
          <input
            type="text"
            placeholder={t('categoryModals.areaNamePlaceholder')}
            onChange={handleInputChange}
            className="tw-flex-1 tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent"
          />
        </div>
        <p className="tw-text-xs tw-text-gray-500">{t('categoryModals.areaNameHint')}</p>
      </div>

      {newAreas.length > 0 && (
        <div className="tw-space-y-2">
          <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
            {t('categoryModals.areaToCreate')}
          </label>
          <div className="tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-lg tw-p-3">
            <span className="tw-text-blue-800 tw-font-medium">{newAreas[0]}</span>
          </div>
        </div>
      )}

      {newAreas.length === 0 && (
        <div className="tw-bg-yellow-50 tw-p-3 tw-rounded-lg">
          <p className="tw-text-sm tw-text-yellow-700">
            <Icon name="warning circle" color="yellow" />
            {t('categoryModals.areaNameRequired')}
          </p>
        </div>
      )}
    </div>
  );
};

export default CreateAreaModal;
